module.exports = __webpack_public_path__ + "partner_static/img/newlogo.483ea739.png";